import { render, staticRenderFns } from "./VOLIntegration.vue?vue&type=template&id=60bb0cd4&"
import script from "./VOLIntegration.vue?vue&type=script&lang=ts&"
export * from "./VOLIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./VOLIntegration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports